import { Navigate, useParams } from 'react-router-dom';

export const ReportsVdaRedirect = () => <Navigate to="/tools/vda" replace />;

export const ReportsVdaOrgRedirect = () => {
  const { orgId } = useParams();
  return <Navigate to={orgId ? `/tools/vda/${orgId}` : '/tools/vda'} replace />;
};
